export default "__VITE_ASSET__c_pmxLWL__"